import theme from '../../../../lib/theme';

const { layouts, media, font, scale, colors, corners } = theme;

export default () => ({
  fields: {
    ...layouts.spacedColumn('xs'),

    backgroundColor: colors.white,
    padding: `0 0 ${scale.xs} 0`,
  },

  row: {
    ...layouts.spacedColumn('xs'),
    ...layouts.filled,

    flexDirection: 'column',
    alignItems: 'start',
  },

  input: {
    fontSize: font.s,
    padding: scale.xxs,
  },
  inputContainer: {
    width: '100%',
  },

  label: {
    fontSize: font.s,
    fontWeight: font.normal,
    whiteSpace: 'nowrap',
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 0,
  },

  button: {
    ...layouts.spacedRow('xxs'),
    borderRadius: corners.xl,
    backgroundColor: `${colors.sas.primary_light} !important`,
    color: `${colors.white} !important`,
    borderColor: `${colors.sas.primary_light} !important`,

    '&:hover': {
      backgroundColor: `${colors.sas.primary_light} !important`,
      color: `${colors.white} !important`,
      borderColor: `${colors.sas.primary_light} !important`,
    },
  },

  totalResults: {
    color: colors.sas.primary,
    fontSize: font.m,
    textAlign: 'center',
    width: '30%',
  },

  noFlex: {
    flex: '0 !important',
    minWidth: 53,
  },
});
